<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg">
              <card class="card-eprf">
                <div class="row">
                  <div class="col-lg-3">
                    <p
                      style="color: #5e99ff; font-size: 24px; font-weight: 300"
                    >
                      COLLECTION SCHEDULE
                    </p>
                  </div>
                  <div class="col-lg-6"></div>
                </div>
                <div class="row">
                  <div class="col-lg-3">
                    <p
                      style="
                        color: #A5A5A5;
                        opacity: 0.7;
                        margin-top: -10px;
                        font-size: 15px;
                        font-weight: 300;
                      "
                    >
                      Select collection date: {{ selectedDate }}
                    </p>
                  </div>
                  <div class="col-lg-6"></div>
                </div>
                <div class="row">
                  <div class="col-lg" style="width: 1200px">
                    <full-calendar
                      v-if="displayflag"
                      ref="calendar"
                      @changeMonth="handleMonthChange"
                      :events="demoEvents"
                      @dayClick="dayClick"
                      style="color: #000000 !important"
                      :firstDay="1"
                    >
                    </full-calendar>
                    <full-calendar
                      v-if="!displayflag"
                      :events="demoEvents"
                      style="color: #000000 !important"
                      :firstDay="1"
                    >
                    </full-calendar>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-3 text-right">
              <!-- <base-button
                wide
                type="cancel"
                @click.native="exitTab"
                class="btn-dispute"
              >
                Back
              </base-button> -->

              <!-- &nbsp; -->

              <base-button
                v-if="displayflag"
                type="primary"
                wide
                @click.native="submitDate()"
                class="btn-next"
                :disabled="selectedDate === null || selectedDate === ''"
              >
                Next
              </base-button>
              <base-button
                v-if="!displayflag"
                type="primary"
                wide
                @click.native="nextTab()"
                class="btn-next"
              >
                Next
              </base-button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg"></div>
            <div v-if="!selectedDate" class="col-lg-3 text-right">
              <p style="color: #ff0000; font-size: 12px">
                Please select a date.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FullCalendar from "vue-fullcalendar";

import moment from "moment";

export default {
  components: {
    FullCalendar,
  },
  data() {
    return {
      jobno: "",
      selectedDate: "",
      selectedDate1: null,
      submitted: false,
      demoEvents: [],
      step: 0,
      outgoingid: "",
      status: "",
      positionid: "",
      displayflag: false,
    };
  },
  mounted() {},
  methods: {
    submitDate() {
      console.log("submit date");
      console.log(this.selectedDate);

      let obj = {
        date: this.selectedDate, //YYYY-MM-DD
      };

      this.$http
        .post(":10001/api/v1/outgoing/waste/set_date", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            this.$router.push(
              // "/Outgoing/CreateJob/" + response.outgoing_id + "/add"
              "/OutgoingJobPage/" + response.outgoing_id + "/edit"
            );
            this.getData();
          }
        });
    },

    viewChange(date) {
      this.$refs.calendar.currenctDate = date;
    },
    handleMonthChange(start, end, current) {},
    getData() {
      console.log(this.$route.params)
      if (this.$route.params.jobnum != "create") {
      console.log("masukkk siinin")
      this.$http
        .get(":10001/api/v1/outgoing/waste/" + this.$route.params.jobnum)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            if (response.status.status == 100) {
              let parameter = {
                step: "0",
                direction: "depan",
                data: [],
              };
              this.$emit("my-event", parameter);
            } else {
              let parameter = {
                step: (response.status.status - 1).toString(),
                direction: "depan",
                data: [],
              };
              this.$emit("my-event", parameter);
            }

            this.status = response.status.status;
            this.selectedDate = moment(response.proposed_date).format(
              "YYYY-MM-DD"
            );

            let obj = {
              title: "Collection Date",
              start: moment(response.proposed_date).format("YYYY-MM-DD"),
              end: moment(response.proposed_date).format("YYYY-MM-DD"),
              time: "09:00",
              cssClass: ["chosen"],
            };

            this.demoEvents = [obj];
          }
        });
      }
    },

    //cannot select past date than today
    dayClick(day) {
      let clickedDate = moment(day).startOf("day");

      let today = moment().startOf("day");

      if (clickedDate.isSameOrAfter(today)) {
        this.selectedDate = clickedDate.format("YYYY-MM-DD").toString();

        let obj = {
          title: "Collection Date",
          start: this.selectedDate,
          end: this.selectedDate,
          time: "09:00",
          cssClass: ["chosen"],
        };

        if (!Array.isArray(this.demoEvents)) {
          this.demoEvents = [];
        }

        this.demoEvents = [obj];
      } else {
      }
    },

    nextTab() {
      let parameter = {
        step: "1",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    async exitTab() {
      let parameter = {
        step: "1",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );

    this.getData();
  },
  computed: {},
  watch: {
    positionid() {
      console.log(this.positionid);
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    status() {
      console.log(this.status);
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    displayflag() {
      console.log(this.displayflag);
    },
  },
};
</script>
<style>
.comp-full-calendar {
  min-width: none !important;
  max-width: none !important;
  width: 100%;
  /* background: red; */
}

.header-center {
  text-align: right !important;
}

.header-right {
  display: none;
}

.day-cell .day-number {
  color: #A5A5A5;
}

.day-cell .not-cur-month {
  color: #A5A5A5 !important;
  opacity: 0.5;
}
</style>
